module.exports = __webpack_public_path__ + "img/1482302167.79587d18.jpg";